<template>
  <component
    :is="wrapper"
    :id="`${sectionId}`"
    ref="section"
    :block="block"
    class="fk-block"
    :class="blockClasses(block)"
  >
    <component
      :is="customBlock(block.__component)"
      v-if="customBlock(block.__component) !== false"
      v-bind="block"
    />
    <slot
      v-else
      :name="`${`${block.__component}`.replace('.', '_')}`"
      :block="block"
    >
      {{ block }}
    </slot>
  </component>
</template>
<script setup lang="ts">
import { toRef, computed, provide } from "#imports";
import { useBlock } from "../../composables/useBlock";
import type { StrapiBlock } from "../../../../src/types";
import type { ConcreteComponent } from "vue";

const { blockClasses, blockComponent } = useBlock();
const customBlock = (blockName?: string) => blockComponent(blockName);

const props = withDefaults(
  defineProps<{
    block: StrapiBlock;
    wrapper?: ConcreteComponent | string;
  }>(),
  {
    idx: 0,
    wrapper: "section",
  },
);
const blockSettings = toRef(props.block, "settings");
const sectionId = computed(() => {
  let id = `${props.block.__component?.replace(".", "-")}-${props.block.id}`;
  if (
    blockSettings?.value?.elementId &&
    blockSettings?.value?.elementId !== ""
  ) {
    id = blockSettings?.value?.elementId;
  }
  return id;
});

provide("block", props.block);
</script>
